import React, { useState, useEffect } from 'react';
import './App.css';
import Home from './components/pages/Home';
import HomeSpanish from './components/pages/HomeSpanish';
import HomeNew from './components/pages/HomeNew';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDIF-h5vt1vgzBwfd_f9tS4Q7OZhOULsNI",
  authDomain: "flamingo-cards-com.firebaseapp.com",
  projectId: "flamingo-cards-com",
  storageBucket: "flamingo-cards-com.appspot.com",
  messagingSenderId: "474763631824",
  appId: "1:474763631824:web:5c993810c9804b575c12d5",
  measurementId: "G-GW1DRGL45H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);



const RedirectToExternalSite = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
};





function App() {



  return (
    <>
      <Helmet>
        <meta name="description" content="Welcome to Tipsy Flamingo in English!" />
        <meta name="apple-itunes-app" content="app-id=1537890432, app-argument=https://apps.apple.com/app/apple-store/id1537890432?pt=122101512&ct=website&mt=8" />
        <link rel="apple-touch-icon" sizes="180x180" href="/lottie/180.png" />
        <link rel="apple-touch-icon" sizes="32x32" href="/lottie/32.png" />
        <link rel="apple-touch-icon" sizes="16x16" href="/lottie/16.png" />
      </Helmet>
      <Router>
        <Switch>
          <Route path='/' exact component={Home} />
          <Route path='/download' exact component={HomeNew} />
          <Route path='/app' exact component={HomeNew} />
          <Route path='/es' exact component={HomeSpanish} />
          {/* <Route path='/services' component={Services} />
          <Route path='/products' component={Products} />
          <Route path='/sign-up' component={SignUp} /> */}
        </Switch>
      </Router>
    </>
  );
}

export default App;
